module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAAAsCAMAAADcpCGDAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAADBQTFRF2Oriy9rS193a0ufd8vTz6Onp6vLtyNLM+Pr53+3lzuDY4+/p4OPi0dHR////3u7pNVxRVQAAAQJJREFUeNqE1EsWgyAMBdBAAPkp+99tIVCLEdJMOrmHvIdWuMYEc60Hxq8BQAjO70UqNI0ltxShTIPVvQSU57wFMpG4cAyA5iIxES0XgQlluOAxDt7Wc6GSeQoetN9doiuGZdCJGVje13wxsAw6jSPh92eAhU3Q+yH2M9JexJ5UCKp6W/wnhKBFkxBiDBGEKpaEsAQNCZTKNmHEsk1IQSOJIFZpQlhSMgkUy1bhililCjGob0KKoehNRrnsBR7lslUoFXcIMm056xzHkrWy9YzzO2/WytKTs1n/2Lw0+vlbaPM5sRhhlL0F/bGM1Y+dmovBfjvzUnTmiNm9GNHoK/MRYADgHUxZJImFtwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/components/SP/assets/UT.png
// module id = KdeN
// module chunks = 1